import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./ResetPassword.css";
import { default as Header } from "../../Components/Header2/Header2";
import { default as Footer } from "../../Components/Footer/FooterSmall";
import useAPI from "../../Hooks/useAPI";
import { Console } from "console";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { resetPassword } = useAPI();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters long");
      return;
    }

    const token = searchParams.get("token");
    if (!token) {
      setError("Invalid reset link");
      return;
    }

    try {
      await resetPassword(token, newPassword);
      setSuccess(
        "Password has been reset successfully. You can now login with your new password."
      );
      setTimeout(() => {
        navigate("/user-login");
      }, 3000);
    } catch (err) {
      setError("Invalid reset link");
    }
  };

  return (
    <>
      <Header />
      <div className="reset-password-container">
        <div className="reset-password-card">
          <div className="reset-password-header">
            <h2 className="reset-password-title">Reset Your Password</h2>
            <p className="reset-password-subtitle">
              Please enter your new password below.
            </p>
          </div>

          {error && <div className="error-message">{error}</div>}

          {success && <div className="success-message">{success}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label" htmlFor="newPassword">
                New Password
              </label>
              <input
                type="password"
                id="newPassword"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="form-input"
                required
                minLength={6}
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="confirmPassword">
                Confirm New Password
              </label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="form-input"
                required
                minLength={6}
              />
            </div>

            <button type="submit" className="reset-password-submit-button">
              Reset Password
            </button>
          </form>

          <div className="back-to-login">
            <button
              onClick={() => navigate("/user-login")}
              className="back-button"
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
